<template>
  <div class="box1-container">
    <div class="title">
      <h3>智慧照明</h3>
      <div class="r_block">
        <span></span>
        <em></em>
        <span></span>
      </div>
    </div>

    <div class="content">
      <div class="box1_s">
        <div class="boxs_one">
          <div class="boxs_num">
            <div class="boxs_num_s"><span>{{ itemData.total }}</span></div>
            <div class="boxs_num_text">灯杆总数</div>
          </div>
          <div class="boxs_circle"></div>
          <div class="boxs_bg"><div class="boxs_bg_img"></div></div>
        </div>
        <div class="boxs_one_blue">
          <div class="boxs_num">
            <div class="boxs_num_s"><span>{{ itemData.cost_electricity }}</span>kWh</div>
            <div class="boxs_num_text">总用电量</div>
          </div>
          <div class="boxs_circle"></div>
          <div class="boxs_bg"><div class="boxs_bg_img"></div></div>
        </div>
        <div class="boxs_one_blue">
          <div class="boxs_num">
            <div class="boxs_num_s"><span>{{ itemData.avg_save_electricity }}</span>kWh</div>
            <div class="boxs_num_text">总省电量</div>
          </div>
          <div class="boxs_circle"></div>
          <div class="boxs_bg"><div class="boxs_bg_img"></div></div>
        </div>
      </div>
      <ul class="box1_x">
        <li>
          <div class="icon"><img src="@/assets/home_images/box1/box1_icon1.png" /></div>
          <span>
            {{ itemData.cloud_box }}
            <em>智慧云盒</em>
          </span>
        </li>
        <li>
          <div class="icon"><img src="@/assets/home_images/box1/box1_icon2.png" /></div>
          <span>
            {{ ip }}
            <em>广播</em>
          </span>
        </li>
        <li>
          <div class="icon"><img src="@/assets/home_images/box1/box1_icon3.png" /></div>
          <span>
            {{ camera }}
            <em>监控摄像</em>
          </span>
        </li>
        <li>
          <div class="icon"><img src="@/assets/home_images/box1/box1_icon4.png" /></div>
          <span>
            {{ itemData.wifi }}
            <em>WIFI</em>
          </span>
        </li>
        <li>
          <div class="icon"><img src="@/assets/home_images/box1/box1_icon5.png" /></div>
          <span>
            {{ itemData.air }}
            <em>气象站</em>
          </span>
        </li>
        <li>
          <div class="icon"><img src="@/assets/home_images/box1/box1_icon6.png" /></div>
          <span>
            {{ itemData.g5 }}
            <em>5G基站</em>
          </span>
        </li>
        <li>
          <div class="icon"><img src="@/assets/home_images/box1/box1_icon7.png" /></div>
          <span>
            {{ alarm }}
            <em>一键报警</em>
          </span>
        </li>
        <li>
          <div class="icon"><img src="@/assets/home_images/box1/box1_icon8.png" /></div>
          <span>
            {{ itemData.charging_pile }}
            <em>充电桩</em>
          </span>
        </li>

      </ul>


    </div>

    <div class="bottom">
      <div class="r_block">
        <span></span>
        <em></em>
        <span></span>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "Box1",
  props: {
    itemData: {
      type: Object,
      required: true, // 默认值是false
      default: function () {
        return {
          total:	57,
          online:	3,
          lamp_id:	73,
          cost_electricity:	515.09,
          total_electricity:	630.72,
          avg_cost_electricity:	1.18,
          avg_total_electricity:	1.44,
          save_electricity:	115.63,
          avg_save_electricity:	0.26,
          wifi:	0,
          air:	0,
          g5:	0,
          charging_pile: 1,
        };
      },
    },
    camera: {
      type: Number,
      required: true, // 默认值是false
      default: function () {
        return 0
      }
    },
    ip: {
      type: Number,
      required: true, // 默认值是false
      default: function () {
        return 0
      },
    },
    alarm: {
      type: Number,
      required: true, // 默认值是false
      default: function () {
        return 0
      }
    }
  },
  data() {
    return {}
  },
};
</script>
<style lang='less'>
.box1-container {
  width: 100%;
  height: 100%;
  position: relative;
  .title {
    height:48px;
    display: flex;
    align-items: center;
    justify-content: flex-start ;
    width: 100%;
    background-image: url(../../assets/home_images/title_bg.png);
    background-position: 0 center;
    background-repeat: no-repeat;
    position: relative;
    h3{
      font-size: 20px;
      font-weight: normal;
      color: #fff;
      padding-left: 20px;
      margin:0;
      margin-top:5px;
    }
    .r_block{
      position: absolute;
      right:0;
      bottom:9px;
      display: flex;
      align-items: center;
      span{
        width:3px;
        height:7px;
        background: #1de7ff;
        display: block;
      }
      em{
        width:12px;
        height:7px;
        background: #01162b;
        display: block;
      }
    }
  }
  .bottom{
    height:4px;
    display: flex;
    align-items: center;
    justify-content: flex-start ;
    width: 100%;
    background-image: url(../../assets/home_images/con_bot.png);
    background-position: 0 center;
    background-repeat: no-repeat;
    position: absolute;
    bottom: 0;
    left: 0;
    .r_block{
      position: absolute;
      right:0;
      bottom:0px;
      display: flex;
      align-items: center;
      span{
        width:4px;
        height:4px;
        background: #1de7ff;
        display: block;
      }
      em{
        width:10px;
        height:4px;
        background: #01162b;
        display: block;
      }
    }
  }
  .content {
    position: absolute;
    top: 48px;
    bottom: 4px;
    left: 0;
    right:0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-image: url(../../assets/home_images/con_left.png);
    background-position: 0 0;
    background-repeat: no-repeat;
    box-sizing: border-box;
    padding: 15px 20px;
    .box1_s{
      height:100px;
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      flex-direction: row;
      .boxs_one{
        width:111px;
        height:83px;
        position: relative;
        .boxs_num{
          width:111px;
          height:83px;
          left:0;
          position: absolute;
          top:-83px;
          z-index: 3;
          background-position: center top;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-image: url(../../assets/home_images/box1/text_bg.png);
          display: flex;
          align-items: center;
          flex-direction: column;
          animation: boxs_num 1.5s ease-out 1.5s forwards;
          
          .boxs_num_s{
            width:100%;
            font-size: 12px;
            color:#fff;
            overflow: hidden;
            text-align: center;
            span{
              font-size: 20px;
              font-family: Bahnschrift, Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
              font-style: normal;
            }
          }
          .boxs_num_text{
            font-size: 12px;
            color:#fff;
            margin-top:6px;
          }
        }
        @keyframes boxs_num {
          0% {
            top:-83px;
          }
          100% {
            top:0;
          }
        }
        .boxs_circle{
          width:111px;
          height:28px;
          left:50%;
          position: absolute;
          margin-left:-55.5px;
          bottom: 7px;
          background-position: center center;
          background-repeat: no-repeat;
          background-image: url(../../assets/home_images/box1/boxs_circle.png);
          background-size: 100% 100%;
          animation: boxs_circle 2.5s linear 1.5s infinite;
          z-index: 2;
          opacity: 0;
        }
        @keyframes boxs_circle {
          0% {
            opacity: 1;
            bottom:7px;
          }
          35% {
            opacity: 1;
            bottom:32px;
            transform: scale(1);
          }
          50% {
            opacity: 0;
            bottom:32px;
            transform: scale(1.3);
          }
          100% {
            opacity: 0;
          }
        }
        .boxs_bg{
          position: absolute;
          width:111px;
          height:55px;
          left:0;
          bottom:-55px;
          z-index: 1;
          animation: boxs_bg 1.5s ease-out forwards;
          .boxs_bg_img{
            width:111px;
            height:55px;
            background-position: 0 0;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            animation: boxs_bg_img 1s linear infinite;
          }
          @keyframes boxs_bg_img {
            0% {
              background-image: url(../../assets/home_images/box1/box1_one.png);
            }
            100% {
              background-image: url(../../assets/home_images/box1/box1_one_h.png);
            }
          }
        }
        @keyframes boxs_bg {
          0% {
            bottom:-55px;
          }
          100% {
            bottom:0;
          }
        }
      }
      .boxs_one_blue{
        width:111px;
        height:83px;
        position: relative;
        .boxs_num{
          width:111px;
          height:83px;
          left:0;
          position: absolute;
          top:-83px;
          z-index: 3;
          background-position: center top;
          background-repeat: no-repeat;
          background-image: url(../../assets/home_images/box1/text_bg.png);
          background-size: 100% 100%;
          display: flex;
          align-items: center;
          flex-direction: column;
          animation: boxs_num2 1.5s ease-out 1.5s forwards;
          
          .boxs_num_s{
            width:100%;
            font-size: 12px;
            color:#fff;
            overflow: hidden;
            text-align: center;
            span{
              font-size: 20px;
              font-family: Bahnschrift, Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
              font-style: normal;
            }
          }
          .boxs_num_text{
            font-size: 12px;
            color:#fff;
            margin-top:6px;
          }
        }
        @keyframes boxs_num2 {
          0% {
            top:-83px;
          }
          100% {
            top:0;
          }
        }
        .boxs_circle{
          width:111px;
          height:28px;
          left:50%;
          position: absolute;
          margin-left:-55.5px;
          bottom: 7px;
          background-position: center center;
          background-repeat: no-repeat;
          background-image: url(../../assets/home_images/box1/boxs_circle_blue.png);
          background-size: 100% 100%;
          animation: boxs_circle2 2.5s linear 1.5s infinite;
          z-index: 2;
          opacity: 0;
        }
        @keyframes boxs_circle2 {
          0% {
            opacity: 1;
            bottom:7px;
          }
          35% {
            opacity: 1;
            bottom:32px;
            transform: scale(1);
          }
          50% {
            opacity: 0;
            bottom:32px;
            transform: scale(1.3);
          }
          100% {
            opacity: 0;
          }
        }
        .boxs_bg{
          position: absolute;
          width:111px;
          height:55px;
          left:0;
          bottom:-55px;
          z-index: 1;
          animation: boxs_bg2 1.5s ease-out forwards;
          .boxs_bg_img{
            width:111px;
            height:55px;
            background-position: 0 0;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            animation: boxs_bg_img2 1s linear infinite;
          }
          @keyframes boxs_bg_img2 {
            0% {
              background-image: url(../../assets/home_images/box1/box1_one_blue.png);
            }
            100% {
              background-image: url(../../assets/home_images/box1/box1_one_blue_h.png);
            }
          }
        }
        @keyframes boxs_bg2 {
          0% {
            bottom:-55px;
          }
          100% {
            bottom:0;
          }
        }
      }
    }
    ul.box1_x {
      display: flex;
	    flex-wrap: wrap; 
      list-style: none;
      margin:0;
      padding: 0;
      li {
        width: 25%; 
        display: flex;
        align-items: center;
        // justify-content: center;
        overflow: hidden;
        margin-top:20px;
        .icon{
          width:30px;
          height:30px;
          background: #062b3d;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 10px;
          border-radius: 5px;
          img{
            width:20px;
            height:20px;
          }
        }
        span {
          display: block;
          font-size: 18px;
          font-weight: normal;
          color: #fff;
          font-family: Bahnschrift, Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
          display: flex;
          flex-direction: column;
          margin-left:8px;
          em{
            font-size:10px;
            color:#fff;
            display: block;
            font-style: normal;
          }
        }
        
      }
    }

    .left-box2 {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      align-items: center;
      padding: 10px 0;
      width: 95%;
      .tit-text {
        color: rgba(255, 255, 255, 0.7);
        font-size: 14px;
        line-height: 1.5;
        .item_one{
          padding:5px 0;
          line-height: 1.3;
          span{
            font-size: 20px;
            color:#00bbac;
            font-family: Bahnschrift, Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
            font-style: normal;
          }
          .red{
            color:#e23064
          }
        }
        .today{
          font-size: 12px;
          span{
            font-size: 18px;
          }
        }
        
      }
      img {
        width: auto;
        height: 40px;
      }
    }

  }
}
</style>
